export default "__VITE_ASSET__C5a7HAVb__"